import gql from "graphql-tag";

/**
 * Retrieves commodity program data from an API endpoint and stores it in the specified view variable
 * @param {Object} _this - The context object (e.g., Vue component instance) containing reactive state
 * @param {string} fieldName - The name of the variable in the view where the fetched data will be stored
 * @param {string} fieldShowLoadingName - The name of the variable in the view to control the loading state
 * @returns {Promise<Object>} A promise that resolves with the fetched commodity program data or rejects with an error
 */
export function getCommodityProgram(_this, fieldName, fieldShowLoadingName) {
  _this[fieldShowLoadingName] = true;

  _this.$apollo
    .query({
      query: gql`
        query(
          $format: String
          $commodity: Int
          $portfolios: portfoliosList
          $refresh: String
        ) {
          commodity_program(
            format: $format
            commodity: $commodity
            portfolios: $portfolios
            refresh: $refresh
          ) {
            fk_idportfolio
            fk_idcommodity
            fk_userprogram
            created_at
            objective
            parameters
            flow
          }
        }
      `,
      variables: {
        format: "json",
        commodity: parseInt(_this.commodityNumber),
        portfolios: { id_portfolios: _this.portfolioNumbers },
        refresh: Date().toLocaleString()
      }
    })
    .then(data => {
      if (
        _this.modal_processing_message !== undefined &&
        data["data"]["commodity_program"].length > 0
      ) {
        let localData = [];
        let hTot = 0;
        _this.selectedCashFlowGradient =
          data["data"]["commodity_program"][0].parameters;
        if (_this.selectedCashFlowGradient === "monthly") {
          _this.selectedCashFlowGradient =
            data["data"]["commodity_program"][0].parameters;
          data["data"]["commodity_program"].map(function(d) {
            d.flow = JSON.parse(d.flow);
            _this.cashFlowMonths = Object.keys(d.flow.values).length;
            _this.exampleDataRaw.forEach(function(b) {
              if (b.id < _this.cashFlowMonths) {
                localData.push({
                  id: b.id,
                  date: "",
                  balance: b.balance,
                  cashFlow: b.cashFlow,
                  hedge: (d.flow.values[b.id] / 100) * (b.balance + b.cashFlow),
                  percentage: d.flow.values[b.id]
                });
              }
            });
          });
          hTot = localData.map(d => d.hedge).reduce((a, b) => a + b);
          _this.balanceTotal = _this.exampleDataRaw
            .map(d => d.balance)
            .reduce((a, b) => a + b);
          _this.cashFlowTotal = _this.exampleDataRaw
            .map(d => d.cashFlow)
            .filter((d, i) => i < _this.cashFlowMonths)
            .reduce((a, b) => a + b);
          _this.cashFlowPercentage = Math.round(
            (100 * hTot) / (_this.balanceTotal + _this.cashFlowTotal)
          );
        }
        if (_this.selectedCashFlowGradient === "quarterly") {
          data["data"]["commodity_program"].map(function(d) {
            d.flow = JSON.parse(d.flow);
            _this.cashFlowMonths = Object.keys(d.flow.values).length * 3;
            let array_percentages = [];
            for (let i in d.flow.values) {
              array_percentages.push(d.flow.values[i]);
            }
            let count = 0;
            _this.exampleDataRaw.forEach(function(b) {
              if (b.id < _this.cashFlowMonths) {
                if (b.id % 3 === 0 && b.id !== 0) {
                  count = count + 1;
                }
                localData.push({
                  id: b.id,
                  date: "",
                  balance: b.balance,
                  cashFlow: b.cashFlow,
                  hedge:
                    (array_percentages[count] / 100) * (b.balance + b.cashFlow),
                  percentage: array_percentages[count]
                });
              }
            });
          });
          _this.exampleData = localData;
          hTot = localData.map(d => d.hedge).reduce((a, b) => a + b);
          _this.balanceTotal = _this.exampleDataRaw
            .map(d => d.balance)
            .reduce((a, b) => a + b);
          _this.cashFlowTotal = _this.exampleDataRaw
            .map(d => d.cashFlow)
            .filter((d, i) => i < _this.cashFlowMonths)
            .reduce((a, b) => a + b);
          _this.cashFlowPercentage = Math.round(
            (100 * hTot) / (_this.balanceTotal + _this.cashFlowTotal)
          );
        }
        if (_this.selectedCashFlowGradient === "budget") {
          data["data"]["commodity_program"].map(function(d) {
            d.flow = JSON.parse(d.flow);
            _this.cashFlowBudgetMonth = d.flow.values.percentagemonths;
            _this.cashFlowPercentage = d.flow.values.percentage;
          });
        }
        if (_this.selectedCashFlowGradient === "constant") {
          data["data"]["commodity_program"].map(function(d) {
            d.flow = JSON.parse(d.flow);
            _this.cashFlowMonths = d.flow.values.months;
            _this.cashFlowPercentage = d.flow.values.percentage;
          });
        }
        Object.assign(_this.modal_processing_message, {
          showModalLoading: false,
          optionsModal: true
        });
        _this[fieldName] = data["data"]["commodity_program"];
        _this[fieldShowLoadingName] = false;
      } else {
        if (typeof _this.programDataModel !== "undefined") {
          Object.assign(_this.modal_processing_message, {
            showModalLoading: true,
            messageModal: "No program found for this portfolio",
            optionsModal: true
          });
        } else {
          data["data"]["commodity_program"].forEach(function(d) {
            d.currency = d.fk_idcommodity;
            // d.flow = JSON.parse(d.flow.replace(/'/g, '"'));
          });
          _this[fieldName] = data["data"]["commodity_program"];
          _this[fieldShowLoadingName] = false;
        }
      }
    })
    .catch(function(error) {
      Object.assign(_this.modal_processing_message, {
        showModalLoading: false,
        messageModal: "",
        optionsModal: true
      });
      _this[fieldShowLoadingName] = false;
      console.log(error);
    });
}
